import { render, staticRenderFns } from "./plandecarrera.vue?vue&type=template&id=59c1be43&lang=html"
import script from "./plandecarrera.vue?vue&type=script&lang=js"
export * from "./plandecarrera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports